<template>
	<div class="indicator_blood_pressure_edit">
		<van-form>
			<div class="form_item">
				<van-cell title="记录档案" :value="params.patientName"></van-cell>
				<van-field
					label="糖尿病情况"
					:value="strokeDiabetesOptions[params.isDiabetes]"
					input-align="right"
					readonly
					placeholder="请选择"
					is-link
					@click="pickerDiabetesVisible = true"
				></van-field>
			</div>
			<div class="form_item">
				<van-field
					label="测量日期"
					input-align="right"
					:value="params.measureDate"
					readonly
					placeholder="请选择"
					is-link
					@click="pickerDateVisible = true"
				></van-field>
				<van-field
					label="测量时间"
					input-align="right"
					:value="params.measureTime"
					readonly
					placeholder="请选择"
					is-link
					@click="pickerTimeVisible = true"
				></van-field>
				<van-field
					type="number"
					label="血糖值"
					v-model="params.bloodSugar"
					input-align="right"
					placeholder="请输入"
					@blur="blurBloodSugar"
				>
					<template #button>
						<span>mmol/L</span>
					</template>
				</van-field>
				<van-cell title="类型" class="type_cell">
					<van-button
						class="cell_btn"
						v-for="(item, key) in $status.bloodSugarType"
						:key="key"
						:class="{ active: params.sugarType == key }"
						size="small"
						@click="params.sugarType = key"
					>
						{{ item }}
					</van-button>
				</van-cell>
			</div>
		</van-form>

		<foot-button>
			<van-button color="#F5F6F7" block @click="clickDelete" v-if="$route.params.id">
				<span style="color: #1F2329;">删除</span>
			</van-button>
			<van-button type="primary" block @click="clickSubmit">保存</van-button>
		</foot-button>

		<!--糖尿病情况-->
		<van-popup v-model="pickerDiabetesVisible" position="bottom">
			<van-picker
				:value="params.strokeType"
				title="您是否有糖尿病"
				show-toolbar
				:columns="strokeDiabetesOptions"
				@confirm="clickDiabetesPickerConfirm"
				@cancel="pickerDiabetesVisible = false"
			/>
		</van-popup>
		<!--日期-->
		<van-popup v-model="pickerDateVisible" position="bottom">
			<van-datetime-picker
				:value="params.measureDate || new Date()"
				type="date"
				title="选择日期"
				:formatter="$utils.vantDateTimePickerFormatter"
				:max-date="maxDate"
				@confirm="clickDatePickerConfirm"
				@cancel="pickerDateVisible = false"
			/>
		</van-popup>
		<!--时间-->
		<van-popup v-model="pickerTimeVisible" position="bottom">
			<van-datetime-picker
				:value="params.measureTime || $moment().format('HH:mm')"
				type="time"
				title="选择时间"
				:formatter="$utils.vantDateTimePickerFormatter"
				@confirm="clickTimePickerConfirm"
				@cancel="pickerTimeVisible = false"
			/>
		</van-popup>
	</div>
</template>

<script>
import MixinEdit from './mixins/edit'
export default {
    name: 'indicatorBloodPressure',
    data: () => ({
        params: {
            isDiabetes: '',
            bloodSugar: '',
            measureDate: '',
            measureTime: '',
            patientName: '',
            sugarType: ''
        },
        pickerDiabetesVisible: false,
        maxDate: new Date()
    }),
    mixins: [MixinEdit],
    computed: {
        strokeDiabetesOptions () {
            return ['否', '是']
        }
    },
    methods: {
        getApi (apiKey) {
            const apis = {
                saveApi: this.$api.indicator.saveBloodSugarRecord,
                updateApi: this.$api.indicator.updateBloodSugarRecord,
                deleteApi: this.$api.indicator.bloodSugarDelete,
                detailApi: this.$api.indicator.bloodSugarDetail
            }
            return apis[apiKey]
        },
        blurBloodSugar () {
            const val = this.params.bloodSugar
            if (val !== '') {
                this.$set(this.params, 'bloodSugar', Number(val).toFixed(1))
            }
        },
        // 确认选择卒中类型
        clickDiabetesPickerConfirm (value) {
            this.$set(this.params, 'isDiabetes', this.strokeDiabetesOptions.indexOf(value) + '')
            this.pickerDiabetesVisible = false
        },
        // 提交校验
        submitVerify () {
            const emptyItem = Object.entries(this.params).find(item => !item[1])
            if (emptyItem) {
                console.log(emptyItem)
                this.$toast(`请将数据填写完整`)
                return false
            }
            if (this.params.bloodSugar > 33.3 || this.params.bloodSugar < 1.1) {
                this.$toast(`血糖值应在1.1~33.3范围内`)
                return false
            }
            return true
        }
    }
}
</script>

<style scoped lang="less">
.indicator_blood_pressure_edit {
	min-height: calc(100vh - 216px);
	padding: 40px 32px;
	.form_item {
		& + .form_item {
			margin-top: 38px;
		}
		border-radius: 16px;
		overflow: hidden;
		.cell_btn {
			width: 128px;
			height: 68px;
			border-radius: 12px;
			box-sizing: border-box;
			border: 1px solid #dee0e3;
			line-height: 68px;
			font-family: PingFangSC-Regular;
			font-size: 30px;
			font-weight: normal;
			line-height: 34px;
			color: #1f2329;
			& + .cell_btn {
				margin-left: 20px;
			}
			&.active {
				border-color: @primary;
				background-color: @primary;
				color: #fff;
			}
		}
	}
}
</style>
<style lang="less">
.indicator_blood_pressure_edit {
	.form_item {
		.van-cell {
			&::after {
				width: 100%;
			}
			padding-top: 32px;
			padding-bottom: 32px;
			.van-cell__title {
				font-family: PingFangSC-Medium;
				font-size: 30px;
				font-weight: normal;
				color: #1f2329;
			}
			.van-cell__value {
				font-family: PingFangSC-Regular;
				font-size: 30px;
				font-weight: normal;
				color: #1f2329;
			}
			&.type_cell {
				padding-top: 21px;
				padding-bottom: 21px;
				.van-cell__title {
					line-height: 68px;
					width: 80px;
					flex: none;
				}
			}
		}
	}
}
</style>
